import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 5}px;
  z-index: 15;
`;

export const Position = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${({ theme }) => theme.CONSTANTS.XH * 5}px;
`;

export const Group = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: column;
  gap: ${({ theme }) => theme.CONSTANTS.XH * 2}px;
`;
